import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { changeCustomersStatus, getOrganizationData, getSaleOrder, updateBankStatus, updateOrganizationStatus } from "../../../services/api";
import { TableContainer, Tab, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Checkbox, Tabs, CircularProgress } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { getCustomers, getBanks } from "./../../../services/api";

const tableConstruct = {
  "customer.title": {
    ID: (row) => row.id,
    "customer.name": (row) => row.name,
    "customer.shortName": (row) => row.shortname,
    "customer.taxCode": (row) => row.tax_code,
    "customer.code": (row) => row.code,
    "customer.address": (row) => row.address,
  },
  "bank.title": {
    ID: (row) => row.id,
    "bank.code": (row) => row.code,
    "bank.vi_name": (row) => row.vi_name,
    "bank.en_name": (row) => row.en_name,
    "bank.vi_address": (row) => row.vi_address,
    "bank.en_address": (row) => row.en_address,
    "bank.cif": (row) => row.cif,
    "bank.account_number": (row) => row.account_number,
  },
  "sale_order.title": {
    ID: (row) => row.id,
    "sale_order.customer": (row) => row.customer?.id,
    "sale_order.order_no": (row) => row.so_no,
    "sale_order.bank": (row) => row.bank?.vi_name,
    "sale_order.invoice_type": (row) => row.invoice_type,
    "sale_order.currency": (row) => row.currency,
    "sale_order.effect_date": (row) => moment(row.effective_date).format("DD-MM-YYYY HH:mm"),
    "sale_order.exp_date": (row) => moment(row.exp_date).format("DD-MM-YYYY HH:mm"),
    "sale_order.update_date": (row) => moment(row.updated_at).format("DD-MM-YYYY HH:mm"),
  },
  "organization.title": {},
};
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  table: {
    minWidth: 650,
  },
}));

const MasterData = () => {
  const [t] = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const classes = useStyles();
  const [masterData, setMasterData] = useState("loading");
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung data can cap nhat
  const [tab, setTab] = useState(Object.keys(tableConstruct)[0]);
  const tabRef = useRef();
  const getData = () => {
    switch (tab) {
      case "customer.title":
        return getCustomers();
      case "bank.title":
        return getBanks();
      case "sale_order.title":
        return getSaleOrder();
      case "organization.title":
        return getOrganizationData();
      default:
        return;
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleEnableButton = () => {
    switch (tab) {
      case "customer.title":
        return changeCustomersStatus({ ids: changeIds });
      case "bank.title":
        return updateBankStatus({ ids: changeIds });
      case "organization.title":
        return updateOrganizationStatus({ ids: changeIds });
      default:
    }
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleResponse = (res) => {
    if (res.code === 200 && tabRef.current === tab) {
      setMasterData((prev) => prev.map((item) => (res.data.includes(item.id) ? { ...item, status: item.status === 0 ? 1 : 0 } : item)));
      setChangeIds([]);
    }
  };
  useEffect(() => {
    setPage(0);
    tabRef.current = tab;
    setChangeIds([]);
    setMasterData("loading");
    try {
      getData().then((res) => {
        if (res.code !== 200) return;
        tabRef.current === tab && setMasterData(res.data);
      });
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);
  const TableComponent = () => {
    if (masterData === "loading")
      return (
        <div align="center">
          <CircularProgress />
        </div>
      );
    else
      return (
        <div align="left">
          <h1 align="center">{t(tab)}</h1>
          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  {Object.keys(tableConstruct[tab]).map((key) => (
                    <TableCell key={key}>{t(key)}</TableCell>
                  ))}
                  <TableCell align="center">
                    <ButtonWithAPICallComponent disabled={!changeIds.length} variant="contained" api={handleEnableButton} response={handleResponse}>
                      {t("Kích hoạt")}
                    </ButtonWithAPICallComponent>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {masterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  return (
                    <TableRow role="checkbox" tabIndex={-1} key={row.id} hover style={{ cursor: "pointer" }}>
                      {Object.keys(tableConstruct[tab]).map((key) => (
                        <TableCell>{tableConstruct[tab][key](row)}</TableCell>
                      ))}
                      <TableCell align="center">
                        <Checkbox
                          checked={changeIds.includes(row.id) ? !row.status : Boolean(row.status)}
                          sx={{ color: changeIds.includes(row.id) ? "green" : "" }}
                          color={changeIds.includes(row.id) ? "success" : "default"}
                          onClick={handleCheckBoxClick.bind(this, row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={masterData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      );
  };
  return (
    <div className={classes.root} align="left">
      <Tabs onChange={(e, newValue) => setTab(newValue)} value={tab}>
        {Object.keys(tableConstruct).map((key) => (
          <Tab key={key} value={key} label={t(key)} />
        ))}
      </Tabs>
      {masterData && <TableComponent />}

      {/* special table */}
    </div>
  );
};

export default MasterData;
